import {  useSelector } from 'react-redux';
import CommentPanel from 'app/shared-components/chat/CommentPanel';
import {selectCommentPanelPostId} from "app/store/clientsSlice";


function OrganizationRightSidebarContent(props) {
  const commentPanelPostId= useSelector(selectCommentPanelPostId());
  console.log("Inside OrganizationRightSidebarContent");
  console.log(commentPanelPostId);

  if (!commentPanelPostId) return null;
  
  return (
      <CommentPanel postId={commentPanelPostId} isNotes={true} initialMessage="Comment on your note by typing below."  />
  );
}

export default OrganizationRightSidebarContent;
